// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"d84c2208","79":"4c4bbb7a","207":"ea414a91","475":"9f3dd3b0","529":"e476c07e","575":"548ff2f2","732":"90599b8f","768":"f7128814","867":"54b12eb0","880":"6bbc9015","919":"8ec3730a","963":"d540ebae","977":"dbbc1148"}[chunkId] + ".chunk.js";
};